import { ActionReducer, Action } from '@ngrx/store';
import { ERROR, WARNING} from './error-handler.actions';

const defaultErrorHandlerState = {
  errors: <any>[],
  warnings: <any>[]
};

export const errorHandlerReducer: ActionReducer<any> = (state = defaultErrorHandlerState, action: any) => {
  const handler = {
    [ERROR]: () => Object.assign({}, state, { errors: [...state.errors, action.payload], warnings: state.warnings }),
    [WARNING]: () => Object.assign({}, state, { warnings: [...state.warnings, action.payload], errors: state.errors })
  };

  const reducer = handler[action.type];

  return reducer ? reducer() : state;
};
